import { Observable } from 'rxjs';
import { filter, first, map, tap, withLatestFrom } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';

import { selectLoggedUser } from '../../../../auth/auth.selectors';
import { AppState } from '../../../../core.state';
import { Role } from '../../../user/role.enum';
import { LoadPublicHealthRecordNotifications } from '../../store/document-notifications.actions';
import {
    selectNotificationPublicHealthRecordsLoaded
} from '../../store/document-notifications.selectors';

@Injectable({
    providedIn: 'root'
})
export class NotificationPublicHealthRecordsGuard implements CanActivate {
    constructor(private store: Store<AppState>) { }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.checkStore();
    }

    checkStore(): Observable<boolean> {
        return this.store.select(selectNotificationPublicHealthRecordsLoaded).pipe(
            withLatestFrom(this.store.select(selectLoggedUser)),
            map(([loaded, loggedUser]) => {
                if (loggedUser.role === Role.MedicalConsultant || loggedUser.role === Role.SuperAdmin) {
                    return true;
                }
                else {
                    return loaded;
                }
            }),
            tap(loaded => {
                if (!loaded) {
                    this.store.dispatch(new LoadPublicHealthRecordNotifications());
                }
            }),
            filter(loaded => loaded),
            first()
        );
    }
}
